import React from 'react';
import * as Classes from './Share.module.scss';
import ShareIcon from './share.svg';
import { testAttributes } from '../Constants';

export default function Share() 
{
    return (
        <a
            href="#main"
            className={Classes.share}
            data-testid={testAttributes.TABLE_OF_CONTENT_SHARE}
        >
            <img src={ShareIcon} alt="share icon" />
            <span className={Classes.text}>Share</span>
        </a>
    );
}
